/* eslint-disable no-unused-vars */
import { useContext } from 'react';
import axios from 'axios';
import { Buffer } from 'buffer';

import showToast from 'src/components/toastyService';
import { LogContext } from 'src/components/LogProvider';
import { GetIdentifier } from 'src/components/assinatura/auth';

const serverUrl = window.globalConfig.SERVER_URL;

//-------------------------------------------------LOGOUT--------------------------------------------------------------//
export async function Logout() {
  localStorage.clear();
  window.location.href = '/login';
}

//------------------------------------------CHECK-AUTHENTICATION--------------------------------------------------------------//
export function isAuthenticated() {
  const token = localStorage.getItem('token');

  if (token) {
    return true;
  }

  Logout();
  return false;
}

//-------------------------------------------------GET-LOGIN--------------------------------------------------------------//
export async function GetLogin(username, password, setLogData, newId) {
  const getIdentificador = GetIdentifier();
  const id = isValid(newId) ? newId : getIdentificador;

  const payload = {
    username,
    password,
    identificador: id,
  }; //'http://24.144.93.217:3004/api/soap/login'

  return axios
    .post(`${serverUrl}/api/soap/login`, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
      maxBodyLength: Infinity,
    })
    .then((res) => {
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', username);
      localStorage.setItem('identificador', id);
      localStorage.setItem('empUrl', res.data.empresa.url);

      localStorage.setItem('nomeUsu', username);
      //localStorage.setItem('nomeUsu', res.data.nomeUsuario);

      if (isValid(res?.data?.usuario?.administrador))
        localStorage.setItem('IsAdm', res?.data?.usuario?.administrador);

      if (setLogData)
        setLogData([
          {
            status: 'success',
            origem: 'Sistema',
            msg: '',
            icon: 'login',
            hora: getHora(),
            payload: JSON.stringify(payload),
            response: 'token: *',
          },
        ]);

      return res.data;
    })
    .catch((error) => {
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data ||
        error.message ||
        'Erro desconhecido';

      showToast('error', errorMessage);

      if (setLogData)
        setLogData((prevLogData) => [
          ...prevLogData,
          {
            status: 'error',
            origem: 'Sistema',
            msg: 'SOAP Login',
            icon: 'login',
            hora: getHora(),
            payload: JSON.stringify(payload),
            response: errorMessage,
          },
        ]);

      return Promise.reject(new Error(errorMessage));
    });
}

export async function GetPermissoes() {
  const token = localStorage.getItem('token');
  const identificador = localStorage.getItem('identificador');
  const empUrl = localStorage.getItem('empUrl');

  const config = {
    method: 'post',
    url: `${serverUrl}/api/soap/process`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    data: {
      porta: 'GetPermissao',
      identificador,
      retorno: 'json',
      url: `${empUrl}_gestao`,
      data: {},
    },
  };

  try {
    const response = await axios.request(config);

    ShowMsgRet(response);

    const rawJson = response.data.data.arqJso;

    if (!rawJson || rawJson.trim() === '') {
      throw new Error('Permissões não concedidas ou inválidas.');
    }

    let json;
    try {
      json = JSON.parse(rawJson);
    } catch (parseError) {
      throw new Error('Permissões não concedidas ou inválidas.');
    }

    localStorage.setItem('menus', rawJson);
    localStorage.setItem('idEmp', parseFloat(json.codemp));
    localStorage.setItem('idFil', parseFloat(json.codfil));

    setTimeout(() => {
      window.location.href = '/home';
    }, 1000);

    return response.data;
  } catch (error) {
    const errorMessage =
      error.message ||
      error.response?.data?.message ||
      error.response?.data ||
      'Erro desconhecido';

    return Promise.reject(new Error(errorMessage));
  }
}

//-------------------------------------------------PROCESSO--------------------------------------------------------------//
export async function setCache(data, key) {
  // eslint-disable-next-line no-unreachable
  const cache = JSON.parse(localStorage.getItem('cache')) || [];

  const updatedCache = cache.filter((item) => item.key !== key);
  updatedCache.push({ key: key, value: data });

  localStorage.setItem('cache', JSON.stringify(updatedCache));
}

export async function GetProcesso(porta, data, usarGestao, usarCache) {
  const token = localStorage.getItem('token');
  const identificador = localStorage.getItem('identificador');
  const empUrl = localStorage.getItem('empUrl');
  const parsedData = typeof data === 'object' ? data : JSON.parse(data);

  const url = usarGestao === false ? empUrl : `${empUrl}_gestao`;

  const disable = false;

  const config = {
    method: 'post',
    url: `${serverUrl}/api/soap/process`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    data: {
      porta,
      identificador,
      url: url,
      retorno: 'json',
      data: parsedData,
    },
  };

  try {
    const cache = JSON.parse(localStorage.getItem('cache')) || [];
    const cacheItem = cache.find(
      (item) => item.key === `${porta}${JSON.stringify(data)}`
    );

    if (disable && usarCache && cacheItem) {
      return cacheItem.value;
    }

    const response = await axios.request(config);

    ShowMsgRet(response);

    if (disable && usarCache)
      setCache(response.data.data, `${porta}${JSON.stringify(data)}`);

    const innerData = response.data?.data ?? {};
    const outerData = response.data ?? {};

    return {
      ...innerData,
      tipRet: innerData.tipRet ?? outerData.tipRet,
      msgRet:
        innerData.msgRet ??
        innerData.msgret ??
        outerData.msgRet ??
        outerData.msgret,
    };
  } catch (error) {
    let msg =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Erro desconhecido';

    showToast('error', msg);
    return error;
  }
}
export async function LogGetProcesso(porta, data, usarGestao, usarCache) {
  console.log(' ----=====Teste Processo=====-----');
  const token = localStorage.getItem('token');
  const identificador = localStorage.getItem('identificador');
  const empUrl = localStorage.getItem('empUrl');
  const parsedData = typeof data === 'object' ? data : JSON.parse(data);

  const url = usarGestao === false ? empUrl : `${empUrl}_gestao`;

  const disable = false;

  const config = {
    method: 'post',
    url: `${serverUrl}/api/soap/process`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    data: {
      porta,
      identificador,
      url: url,
      retorno: 'json',
      data: parsedData,
    },
  };

  console.log(config);
  console.log(' ----======[[[[[[[]]]]]]]=====-----');
  return;
}

export async function GetDynamic(method, endereco, data, usarCache) {
  const token = localStorage.getItem('token');

  const disable = false;

  const config = {
    method: method,
    url: `${serverUrl}/api/${endereco}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    data: data || '',
  };

  try {
    const cache = JSON.parse(localStorage.getItem('cache')) || [];
    const cacheItem = cache.find(
      (item) => item.key === `${endereco}${JSON.stringify(data)}`
    );
    if (disable && usarCache && cacheItem) {
      //showToast('warning', 'cod.B- USOU CACHE !!!');
      return cacheItem.value;
    }
    /*showToast(
      'warning',
      usarCache ? 'cod.A- SEM USAR CACHE !!!' : 'cod.C- NAO PODE USAR CACHE'
    );*/

    const response = await axios.request(config);

    ShowMsgRet(response);

    if (disable && usarCache)
      setCache(response.data.data, `${endereco}${JSON.stringify(data)}`);

    return response.data.data;
  } catch (error) {
    let msg =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Erro desconhecido';

    showToast('error', msg);
    return error;
  }
}

export async function GetConsulta(url, porta, data, usarCache) {
  const token = localStorage.getItem('token');
  const identificador = localStorage.getItem('identificador');
  const parsedData = typeof data === 'object' ? data : JSON.parse(data);

  const disable = true;

  const config = {
    method: 'post',
    url: `${serverUrl}/api/soap/process`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    data: {
      porta,
      identificador,
      url: url,
      retorno: 'json',
      data: parsedData,
    },
  };

  try {
    const cache = JSON.parse(localStorage.getItem('cache')) || [];
    const cacheItem = cache.find(
      (item) => item.key === `${porta}${JSON.stringify(data)}`
    );
    if (disable && usarCache && cacheItem) {
      //showToast('warning', 'cod.B- USOU CACHE !!!');
      return [cacheItem.value, true];
    }
    /*showToast(
      'warning',
      usarCache ? 'cod.A- SEM USAR CACHE !!!' : 'cod.C- NAO PODE USAR CACHE'
    );*/

    const response = await axios.request(config);

    ShowMsgRet(response);

    if (disable && usarCache)
      setCache(response.data.data, `${porta}${JSON.stringify(data)}`);

    return [response.data.data, false];
  } catch (error) {
    let msg =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Erro desconhecido';

    // Se a mensagem for XML, extrair o <faultstring>
    const match = msg.match(/<faultstring>(.*?)<\/faultstring>/);
    if (match && match[1]) {
      msg = match[1];
    }

    showToast('error', msg);
    return {};
  }
}

//--------------TEMPORARIO---------------------------------------
export async function GetLogs(method, endereco, data, usarCache) {
  const token = localStorage.getItem('token');
  const disable = false;

  const config = {
    method: method,
    url: `${serverUrl}/api/${endereco}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    data: data || '',
  };

  try {
    const cache = JSON.parse(localStorage.getItem('cache')) || [];
    const cacheItem = cache.find(
      (item) => item.key === `${endereco}${JSON.stringify(data)}`
    );
    if (disable && usarCache && cacheItem) {
      //showToast('warning', 'cod.B- USOU CACHE !!!');
      return cacheItem.value;
    }
    /*showToast(
      'warning',
      usarCache ? 'cod.A- SEM USAR CACHE !!!' : 'cod.C- NAO PODE USAR CACHE'
    );*/

    const response = await axios.request(config);

    if (response.data?.data?.tipRet === 1)
      showToast('success', response.data.data.msgRet);

    let errorMessage =
      response?.data?.msgRet ||
      response?.data?.erroExecucao ||
      response?.message ||
      '';

    if (response.data?.data?.tipRet === 2) showToast('error', errorMessage);

    if (disable && usarCache)
      setCache(response.data?.data, `${endereco}${JSON.stringify(data)}`);

    return response.data;
  } catch (error) {
    let msg =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Erro desconhecido';

    showToast('error', msg);
    return error;
  }
}

export async function DeleteDynamic(endereco) {
  const token = localStorage.getItem('token');

  const config = {
    method: 'DELETE',
    url: `${serverUrl}/api/${endereco}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = await axios.request(config);

    ShowMsgRet(response);

    return response.data.data;
  } catch (error) {
    let msg =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Erro desconhecido';

    showToast('error', msg);
    return error;
  }
}

//------------------TOOLS------------------------------

export function isValid(value) {
  if (
    value != null &&
    value != undefined &&
    value != '' &&
    value != ' ' &&
    value != [] &&
    value != {}
  )
    return true;
  else return false;
}

function getHora() {
  const date = new Date();
  const dia = date.toLocaleDateString();
  const horas = date.getHours();
  const m = String(date.getMinutes()).padStart(2, '0');

  return `${horas}:${m} ${dia}`;
}

export function transformResponse(data, campo) {
  var XMLParser = require('react-xml-parser');
  var xml = new XMLParser().parseFromString(data);

  const procurarCampo = xml.getElementsByTagName(campo);

  const transformedResponse = procurarCampo.map((item, index) => {
    return item;
  });

  return transformedResponse;
}

export function transformJson(data, campo) {
  var XMLParser = require('react-xml-parser');
  var xml = new XMLParser().parseFromString(data);

  const procurarCampo = xml.getElementsByTagName(campo);

  if (!procurarCampo.length) {
    showToast('error', `Campo ${campo} não encontrado.`);

    return [];
  }

  try {
    const colunas = JSON.parse(procurarCampo[0].value);

    return colunas;
  } catch (error) {
    let msg =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Erro desconhecido';

    showToast('error', msg);
    return [];
  }
}

export function isRetornoSucesso(data) {
  if (!data || data.isAxiosError || data.response) return false;
  const tipRet = Number(data?.tipRet);
  return tipRet === 1 || tipRet === 3;
}

export function ShowMsgRet(response) {
  const tipRet = parseFloat(response.data?.tipRet);
  const tipRet2 = parseFloat(response.data?.data?.tipRet);

  const msg = response.data?.msgRet || response.data?.msgret;
  const msg2 = response.data?.data?.msgRet || response.data?.data?.msgret;

  if (tipRet === 3 || tipRet2 === 3) {
    showToast('success', msg || msg2 || 'Operação realizada com sucesso.');
    return;
  }

  if (tipRet === 1 && isValid(msg)) {
    showToast('success', msg);
  } else if (tipRet2 === 1 && isValid(msg2)) {
    showToast('success', msg2);
  } else if (tipRet === 1 || tipRet2 === 1) {
    showToast('success', msg || msg2 || 'Operação realizada com sucesso.');
  }

  const errorExecucao =
    response?.data?.erroExecucao || response?.data?.data?.erroExecucao;
  const errorMsg =
    response?.message ||
    response?.data?.message ||
    response?.data?.data?.message;

  if (tipRet === 2 && isValid(msg)) {
    showToast('error', msg || errorExecucao || errorMsg || 'Erro Desconhecido');
  } else if (isValid(msg2) && tipRet === tipRet2) {
    showToast(
      'error',
      msg2 || msg || errorExecucao || errorMsg || 'Erro Desconhecido'
    );
  }
}
